<script setup lang="ts">
  import { DestinationMobile } from '@/features/searchForm/destination';
  import MobilePageHeader from '@/shared/ui/MobilePageHeader.vue';
  import MobileScreen from '@/shared/ui/MobileScreen.vue';
  import { useMobileSearchFlowContext } from '../../../model/useMobileSearchFlow';

  const flow = useMobileSearchFlowContext();
</script>

<template>
  <MobileScreen
    name="mobile-destination-screen"
    testid="search-form-mobile-destination"
    :embedded="flow.embedded"
  >
    <DestinationMobile
      class="mobile-destination-screen__body"
      :title="flow.texts.labels.destination"
      :model-value="flow.destination.value"
      :countries="flow.countries.value"
      :history="flow.historySearch.value"
      :has-switched-country="flow.hasSwitchedCountry.value"
      @update:modelValue="flow.updateDestination"
      @update:hasSwitchedCountry="flow.markSwitchedCountry"
      @next="flow.onDestinationNext"
      @close="flow.back"
    >
      <template #header="{ title, back }">
        <MobilePageHeader
          class="mobile-destination-screen__header"
          :title="title"
          @back="back"
        />
      </template>
    </DestinationMobile>
  </MobileScreen>
</template>

<style scoped lang="scss">
  .mobile-destination-screen {
    background: var(--color-bg-primary);

    &__header {
      padding: var(--spacing-s) var(--spacing-m) var(--spacing-xs) var(--spacing-m);
    }

    &__body {
      flex: 1 1 auto;
      min-height: 0;
    }
  }
</style>
